import Emitter from "@homer.core/emitter";
import isObject from "@homer.utility/validator.isobject";

const matchMethod = /^(?:GET|POST|PUT|PATCH|DELETE|HEAD|CONNECT|OPTIONS|TRACE)$/;

export default class Request extends Emitter {
    constructor(method = "GET", data, header = {}) {
        super();

        if (method && !matchMethod.test(method)) {
            throw new TypeError(
                "Argument `method` must be one of `GET`, `POST`, `PUT`, `PATCH`, `DELETE`, `HEAD`, `CONNECT`, `OPTIONS` or `TRACE`",
            );
        }

        if (header && !isObject(header)) {
            throw new TypeError("Argument `header` must be of type `Object`");
        }

        Object.keys(header).forEach((name) => {
            if (typeof header[name] === "undefined") {
                delete header[name];
            }
        });

        this.method = method;
        this.header = header;
        this.aborted = false;
        this.reason = undefined;
        this.data = data;

        this.once("abort", (event, reason) => {
            this.aborted = true;
            this.reason = reason || undefined;
        });
    }

    abort(reason) {
        if (this.aborted) {
            return;
        }

        this.emit("abort", reason);
    }
}
